export default __webpack_public_path__ + "static/media/UserManagementBanner.83d28abc.png";